import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { passengerDetailsStepDefinition } from "../CheckoutPage/PassengerDetailsFlow/PassengerDetailsStartupFlow";
import { PaymentInitStepDeclaration } from "../CheckoutPage/Payment/Steps/PaymentInitStep";
import { voucherStartupFlowDefinition } from "../CheckoutPage/Voucher/VoucherStartup";
import { BookedPassDetailStepDeclaration } from "./Steps/BookedPassDetailStep";
import { OfferDetailStepDeclaration } from "./Steps/OfferDetailStep";
import { OffersInitStepDeclaration } from "./Steps/OffersInitStep";
import { OfferTransition } from "./Transition/OffersTransition";

export const OffersStartupFlow = new FlowDefinition("OffersFlow");

OffersStartupFlow.addStep(OffersInitStepDeclaration);
OffersStartupFlow.addStep(OfferDetailStepDeclaration);
OffersStartupFlow.addStep(passengerDetailsStepDefinition);
OffersStartupFlow.addStep(voucherStartupFlowDefinition);
OffersStartupFlow.addStep(PaymentInitStepDeclaration);
OffersStartupFlow.addStep(BookedPassDetailStepDeclaration)

OffersStartupFlow.addLink("OffersInit_Step", "OfferDetail_step");
OffersStartupFlow.addLink("OffersInit_Step", "VoucherFlow");
OffersStartupFlow.addLink("OffersInit_Step", "PaymentInit_Step");
OffersStartupFlow.addLink("OffersInit_Step", "PassengerDetailsFlow");

OffersStartupFlow.addLink("OffersInit_Step", "BookedPassDetail_step");

OffersStartupFlow.addLink("OfferDetail_step", "OffersInit_Step");

OffersStartupFlow.addLink("BookedPassDetail_step", "OffersInit_Step");

OffersStartupFlow.setStartStep("OffersInit_Step");

OffersStartupFlow.addTransition(OfferTransition, "OffersInit_Step");
OffersStartupFlow.addTransition(OfferTransition, "OfferDetail_step");

export const OffersStartupStepDefinition = new StepDefinition({
    stepName: "OffersFlow",
    stepFlow: OffersStartupFlow
})
